var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlivenessJoyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 68C53.0015 68 68 53.0015 68 34.5C68 15.9985 53.0015 1 34.5 1C15.9985 1 1 15.9985 1 34.5C1 53.0015 15.9985 68 34.5 68Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4681 21.6674C55.4681 21.6674 53.7402 14.5516 46.2529 13.5916C46.2529 13.5916 39.9774 12.8116 36.9297 19.3275C36.9297 19.3275 45.7489 12.8596 55.4681 21.6674Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6451 28.3036C47.7048 28.3036 50.2006 30.8956 50.2006 34.0875C50.2006 34.4595 50.0686 34.7835 49.9966 35.1315C51.0165 35.5875 52.0604 36.1275 53.1403 36.8955C53.1403 22.0398 46.049 21.6198 44.6571 21.6798C43.2652 21.6198 36.1738 22.0398 36.1738 36.8955C36.1738 36.8955 37.3377 35.8515 39.2816 34.9875C39.2336 34.6755 39.1016 34.3995 39.1016 34.0875C39.1016 30.8956 41.5854 28.3036 44.6571 28.3036H44.6451Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9852 35.1208C50.0452 34.7728 50.1892 34.4488 50.1892 34.0769C50.1892 30.8849 47.7054 28.293 44.6336 28.293C41.5619 28.293 39.0781 30.8849 39.0781 34.0769C39.0781 34.4008 39.2101 34.6768 39.2581 34.9768C41.7299 33.8849 45.4976 33.1169 49.9852 35.1088V35.1208Z",
    fill: "#231F20",
    stroke: "#231F20",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7246 21.6674C12.7246 21.6674 14.4525 14.5516 21.9398 13.5916C21.9398 13.5916 28.2153 12.8116 31.263 19.3275C31.263 19.3275 22.4438 12.8596 12.7246 21.6674Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5597 28.3036C20.5 28.3036 18.0042 30.8956 18.0042 34.0875C18.0042 34.4595 18.1362 34.7835 18.2082 35.1315C17.1883 35.5875 16.1444 36.1275 15.0645 36.8955C15.0645 22.0398 22.1558 21.6198 23.5477 21.6798C24.9396 21.6198 32.031 22.0398 32.031 36.8955C32.031 36.8955 30.8671 35.8515 28.9233 34.9875C28.9712 34.6755 29.1032 34.3995 29.1032 34.0875C29.1032 30.8956 26.6194 28.3036 23.5477 28.3036H23.5597Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2079 35.1208C18.1479 34.7728 18.0039 34.4488 18.0039 34.0769C18.0039 30.8849 20.4877 28.293 23.5594 28.293C26.6312 28.293 29.1149 30.8849 29.1149 34.0769C29.1149 34.4008 28.9829 34.6768 28.9349 34.9768C26.4632 33.8849 22.6955 33.1169 18.2079 35.1088V35.1208Z",
    fill: "#231F20",
    stroke: "#231F20",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6253 53.6642C26.673 55.6801 30.3087 56.9041 34.2684 56.9041C38.708 56.9041 42.7396 55.3802 45.9673 52.9202C41.9357 50.4243 34.6403 50.4123 34.6403 50.4123C27.6209 50.3883 23.9852 53.3522 23.6133 53.6642H23.6253Z",
    fill: "#F01F29",
    stroke: "#F01F29",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2503 42.0371C16.0542 47.293 19.1379 51.7929 23.4576 54.6489C26.5053 56.6648 30.141 57.8888 34.1006 57.8888C38.5403 57.8888 42.5719 56.3648 45.7996 53.9049C49.5553 51.0369 52.2071 46.873 52.951 42.0611C44.8157 45.493 30.8729 48.865 15.2383 42.0371H15.2503Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlivenessJoyIcon);
export default __webpack_public_path__ + "static/media/aliveness-joy-icon.eeb5f505a82523f898aed5ef0a25b30a.svg";
export { ForwardRef as ReactComponent };